/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-notifications-component/dist/theme.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';

import App from './App';
import reportWebVitals from './reportWebVitals';

import getQuery from './utilities/query';
import { BASE_ROUTE } from './utilities/constants';
import TransportProvider from './contexts/ledgerSDK';
import { GlobalProvider } from './contexts/global/context';

import 'react-loading-skeleton/dist/skeleton.css';
import './assets/styles/main.scss';

const container = document.getElementById('root');

const showQueryDevTools =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_QUERY_DEV_TOOLS === 'true';

const title = process.env.REACT_APP_CLIENT_NAME || 'CL Card';

document.title = title;

const root = createRoot(container);

root.render(
  <QueryClientProvider client={getQuery()}>
    <Router basename={BASE_ROUTE}>
      <Switch>
        <Route path="/">
          <GlobalProvider>
            <TransportProvider>
              <App />
            </TransportProvider>
          </GlobalProvider>
        </Route>
      </Switch>
    </Router>
    {showQueryDevTools && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>,
  {
    onUncaughtError: () => {},
    onCaughtError: () => {},
  }
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
